<div id="halloween">

  <div class="halloween-banner">
    <div class="go_button orange sm square" style="position:absolute; top:20px; left:20px;">
      <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
    </div>
    <img src="assets/img/halloween19/halloween-banner.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/halloween19/halloween-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md"
         alt="">
  </div>

  <div class="container">
    <div class="row" style="margin:10px 0;">

        <h1 style="margin:40px; text-align:center;">Select Game</h1>
        <div class="col-md-4 col-xs-6">
          <div class="games_block" routerLink="./fortnite" routerLinkActive="active" style="background:url('../assets/img/halloween19/fortnite-sm.jpg')">
            <img src="assets/img/games/fortnite/logo.png"  width="120" alt="">
          </div>
        </div>

        <div class="col-md-4 col-xs-6">
            <div class="games_block" routerLink="./league-of-legends" routerLinkActive="active" style="background:url('../assets/img/halloween19/league-sm.jpg')">
             <img src="assets/img/games/league-of-legends/logo.png" width="120" alt="">
            </div>
        </div>

        <div class="col-md-4 col-xs-12">
         <div class="games_block" routerLink="./clash-royale" routerLinkActive="active" style="background:url('../assets/img/halloween19/clash-sm.jpg')">
            <img src="assets/img/games/clash-royale/logo.png"  width="140" alt="">
          </div>
        </div>

    </div>
      <div class="row">
          <h1 style="margin:40px; text-align:center;">Tournaments</h1>

          <router-outlet></router-outlet>
      </div>
  </div>

</div>

<div class="halloween_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                         style="width: 80px" alt="GBarena Logo"></a>

  <p>Halloween Nights is hosted and powered by GBarena</p>

  <div style="font-size:18px;">
      <a href="https://facebook.com/gbarena" target="_blank" style="color:#fff">
          <i class="icon-facebook-circled"></i>
      </a>
      <a href="https://twitter.com/gbarenaofficial" target="_blank" style="color:#fff">
          <i class="icon-twitter-circled"></i>
      </a>

      <a href="https://instagram.com/gbarenaofficial" target="_blank" style="color:#fff">
          <i class="icon-instagram-circled"></i>
      </a>

      <a href="http://go.gbarena.com/discord" target="_blank" style="color:#fff; margin-left:5px">
          <img src="../../../../assets/img/icons/discord-logo-white.svg" width="17" />
      </a>
  </div>

</div>
